import React from "react";
import { auth } from "../firebase";
import "./Message.css";
import userAvatarAlternate from "../../images/userAvatarAlt.png";

function Message({ noMessages, message, timestamp, user, userImage, uid }) {
  if (noMessages) return <div className="message">No messages...</div>;

  const messageClass =
    user === auth.currentUser.displayName ? "sent" : "received";

  return (
    <div className={`message ${messageClass}`}>
      <img
        src={userImage}
        alt=""
        onError={(e) => {
          e.target.src = userAvatarAlternate;
          e.target.style =
            "width: 3.125rem; height: 3.125rem; object-fit: contain; border-radius: 50%;";
        }}
      />
      <div className="message__info">
        <h4>
          {user}
          <span className="message__timestamp">
            {new Date(timestamp?.toDate()).toUTCString()}
          </span>
        </h4>
        <p>{message}</p>
      </div>
    </div>
  );
}

export default Message;
